unable to read source [project]/nextapp/node_modules/https-proxy-agent/src/index.ts